import { ILocationZone } from "../../interfaces/esim/EsimPackages.types";

interface LocationZoneSelectorProps {
  search: string;
  setSearch: (value: string) => void;
  selectedZone: ILocationZone | null;
  locationZones: ILocationZone[];
  isInputFocused: boolean;
  setIsInputFocused: (value: boolean) => void;
  onZoneSelect: (zone: ILocationZone) => void;
  onZoneClear: () => void;
}

export const LocationZoneSelector: React.FC<LocationZoneSelectorProps> = ({
  search,
  setSearch,
  selectedZone,
  locationZones,
  isInputFocused,
  setIsInputFocused,
  onZoneSelect,
  onZoneClear
}) => (
  <div className="relative w-full">
    <div className="relative">
      <input
        type="text"
        value={selectedZone ? selectedZone.name : search}
        onChange={(e) => {
          if (selectedZone) {
            onZoneClear();
          }
          setSearch(e.target.value);
        }}
        onFocus={() => setIsInputFocused(true)}
        onBlur={() => setTimeout(() => setIsInputFocused(false), 200)}
        placeholder="Zgjedh zonën..."
        className={`w-full p-2 border border-gray-300 rounded-lg focus:ring-2
          focus:ring-blue-500 focus:border-blue-500 pr-10 ${
          selectedZone ? "pl-8" : ""
        }`}
      />
      {selectedZone && (
        <div className="absolute left-2 top-1/2 transform -translate-y-1/2 flex items-center">
          <img
            src={selectedZone.imageUrl}
            alt={selectedZone.name}
            className="w-4 h-4 object-contain"
          />
        </div>
      )}
      {selectedZone && (
        <button
          onClick={onZoneClear}
          className="absolute right-2 top-1/2 transform -translate-y-1/2
            text-gray-400 hover:text-gray-600"
        >
          ✕
        </button>
      )}
    </div>
    {isInputFocused && locationZones.length > 0 && !selectedZone && (
      <div className="absolute z-10 w-full mt-1 bg-white border rounded-lg
        shadow-lg max-h-48 overflow-y-auto">
        {locationZones.map((zone) => (
          <div
            key={zone.slug}
            onClick={() => onZoneSelect(zone)}
            className="p-2 cursor-pointer hover:bg-gray-100"
          >
            <div className="flex items-center gap-2">
              <img
                src={zone.imageUrl}
                alt={zone.name}
                className="w-4 h-4 object-contain"
              />
              <span>{zone.name}</span>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);
